// eslint-disable-next-line no-use-before-define, prefer-const
let QGIV = QGIV || {};

QGIV.Translators = {
    /**
     *
     * Creates a user-friendly data layer string.
     * @param {number} event Enum that is associated with the data layer event.
     * @returns {string} A user friendly data layer string.
     */
    translateDataLayerEvent(event) {
        switch (event) {
            case QGIV.Enums.DataLayerEvent("QGIV_DONATION_START"):
                return "QGIV.donationStart";
            case QGIV.Enums.DataLayerEvent("QGIV_DONATION_CLOSE"):
                return "QGIV.donationClose";
            case QGIV.Enums.DataLayerEvent("QGIV_DONATION_COMPLETE"):
                return "QGIV.donationComplete";
            case QGIV.Enums.DataLayerEvent("QGIV_DONATION_STEP_CHANGE"):
                return "QGIV.donationStepChange";
            case QGIV.Enums.DataLayerEvent("QGIV_DONATION_PAGE_VIEW"):
                return "QGIV.pageView";
            case QGIV.Enums.DataLayerEvent("QGIV_REGISTRATION_START"):
                return "QGIV.registrationStart";
            case QGIV.Enums.DataLayerEvent("QGIV_REGISTRATION_CLOSE"):
                return "QGIV.registrationClose";
            case QGIV.Enums.DataLayerEvent("QGIV_REGISTRATION_COMPLETE"):
                return "QGIV.registrationComplete";
            case QGIV.Enums.DataLayerEvent("QGIV_REGISTRATION_STEP_CHANGE"):
                return "QGIV.registrationStepChange";
            case QGIV.Enums.DataLayerEvent("QGIV_REGISTRATION_PAGE_VIEW"):
                return "QGIV.pageView";
            case QGIV.Enums.DataLayerEvent("QGIV_GA4_PURCHASE"):
                return "QGIV.ga4Purchase";
            default:
                return "";
        }
    },

    /**
     *
     * Creates a user friendly payment status string.
     * @param {string} status Status that is returned from the submission endpoint.
     * @returns {string|number|undefined} A user friendly payment status string.
     */
    translatePaymentStatus(status) {
        const isNumeric = (num) => !Number.isNaN(num) && Number.isFinite(num);

        if (isNumeric(status)) {
            switch (Number(status)) {
                case QGIV.Enums.PaymentStatus("PaymentStatus.ACCEPTED"):
                    return "Accepted";
                case QGIV.Enums.PaymentStatus("PaymentStatus.CR"):
                    return "Offline";
                case QGIV.Enums.PaymentStatus("PaymentStatus.DECLINED"):
                    return "Declined";
                case QGIV.Enums.PaymentStatus("PaymentStatus.ERROR"):
                    return "Error";
                case QGIV.Enums.PaymentStatus("PaymentStatus.PENDING"):
                    return "Pending";
                case QGIV.Enums.PaymentStatus("PaymentStatus.PROMISE"):
                    return "Promise";
                case QGIV.Enums.PaymentStatus("PaymentStatus.TESTING"):
                    return "Testing";
                case QGIV.Enums.PaymentStatus("PaymentStatus.UNVERIFIED"):
                    return "Unverified";
                case QGIV.Enums.PaymentStatus("PaymentStatus.UPLOADED"):
                    return "Uploaded";
                case QGIV.Enums.PaymentStatus("PaymentStatus.VERIFIED"):
                    return "Verified";
                default:
                    return undefined;
            }
        } else if (status.length === 1 || status.length === 2) {
            switch (status) {
                case "A":
                    return "Accepted";
                case "CR":
                    return "CR";
                case "D":
                    return "Declined";
                case "E":
                    return "Error";
                case "P":
                    return "Pending";
                case "T":
                    return "Testing";
                case "U":
                    return "Voided";
                case "V":
                    return "Verified";
                case "UV":
                    return "Unverified";
                case "PR":
                    return "Promise";
                default:
                    return undefined;
            }
        } else {
            switch (status) {
                case "accepted":
                    return QGIV.Enums.PaymentStatus("ACCEPTED");
                case "cr":
                    return QGIV.Enums.PaymentStatus("CR");
                case "declined":
                    return QGIV.Enums.PaymentStatus("DECLINED");
                case "error":
                    return QGIV.Enums.PaymentStatus("ERROR");
                case "pending":
                    return QGIV.Enums.PaymentStatus("PENDING");
                case "testing":
                    return QGIV.Enums.PaymentStatus("TESTING");
                case "uploaded":
                    return QGIV.Enums.PaymentStatus("UPLOADED");
                case "verified":
                    return QGIV.Enums.PaymentStatus("VERIFIED");
                case "unverified":
                    return QGIV.Enums.PaymentStatus("UNVERIFIED");
                case "promise":
                    return QGIV.Enums.PaymentStatus("PROMISE");
                default:
                    return undefined;
            }
        }
    },

    /**
     *
     * Creates a user friendly payment type string.
     * @param {string} type Type that is returned from the submission endpoint.
     * @param {string} [channel] Channel that is returned from the submission endpoint.
     * @returns {string|undefined} A user friendly payment type string.
     */
    translatePaymentType(type, channel) {
        switch (type) {
            case QGIV.Enums.PaymentTypes("AMERICAN_EXPRESS"):
                return "American Express";
            case QGIV.Enums.PaymentTypes("VISA"):
                return "Visa";
            case QGIV.Enums.PaymentTypes("DISCOVER"):
                return "Discover";
            case QGIV.Enums.PaymentTypes("MASTERCARD"):
                return "MasterCard";
            case QGIV.Enums.PaymentTypes("ECHECK"):
                return "E-Check";
            case QGIV.Enums.PaymentTypes("NO_CHARGE"):
                return "No charge";
            case QGIV.Enums.PaymentTypes("CASH"):
                return "Cash";
            case QGIV.Enums.PaymentTypes("CHECK"):
                return "Check";
            case QGIV.Enums.PaymentTypes("PAYPAL"):
                if (
                    Number(channel) === QGIV.Enums.TransactionChannel("VENMO")
                ) {
                    return "Venmo";
                }
                return "PayPal";
            case QGIV.Enums.PaymentTypes("MATCHING_GIFT"):
                return "Matching";
            case QGIV.Enums.PaymentTypes("BILLTOCARRIER"):
                return "Bill to Carrier";
            case QGIV.Enums.PaymentTypes("FACEBOOK"):
                return "Facebook";
            default:
                return undefined;
        }
    },
};
